/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsmessages1Inputs */

const en_statsmessages1 = /** @type {(inputs: Statsmessages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages`)
};

const de_statsmessages1 = /** @type {(inputs: Statsmessages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachrichten`)
};

/**
* | output |
* | --- |
* | "Messages" |
*
* @param {Statsmessages1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsmessages1 = /** @type {((inputs?: Statsmessages1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsmessages1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsmessages1(inputs)
	return de_statsmessages1(inputs)
});
export { statsmessages1 as "statsMessages" }